<template>
  <div>
    <chart-tooltip />
    <program-spend
      :widget="widget"
      id="program-spend-widget"
      class="program-spend-widget"
      :class="{ 'card--notice': displayNotice }"
      ref="programSpend"
    />
    <ed-notice v-if='displayNotice' :type="noticeType" class="program-spend-widget__notice" icon="fas fa-exclamation-triangle">
      {{noticeMsg}}
    </ed-notice>
  </div>
</template>

<script>

import ProgramSpend from '@/components/_modules/Dashboard/widgets/ProgramBudget'
import ChartTooltip from '@/core/charts/components/chart-tooltip'

export default {
  components: {
    ProgramSpend,
    ChartTooltip
  },

  props: {
    data: Array,
    title: String,
    currency: {
      type: String,
      default: 'USD'
    }
  },

  data() {
    return {
      widget: {
        endPoint: '_',
        dateRangeFilter: {}
      }
    }
  },

  mounted() {
    this.title && this.setTitle()
    this.setData()

    this.$refs.programSpend.load()
  },

  computed: {
    budgetBalance() { return this.data[0][2] },
    revisedBudget() { return this.data[0][1] },

    budgetBalancePercent() {
      return this.budgetBalance <= 0 ? 0 : (this.budgetBalance * 100 / this.revisedBudget)
    },

    displayNotice() {
      return this.budgetBalancePercent < 20
    },

    noticeMsg() {
      let programLabel = global.app.$user.sessionSettings.CompanySettings.ProgramLabel
      if (this.budgetBalance < 0) return programLabel + ' is over budget.'
      return this.budgetBalancePercent < 20
        ? Math.ceil(this.budgetBalancePercent).toFixed(0) + '% of ' + programLabel.toLowerCase() + ' budget remains.'
        : ''
    },

    noticeType() {
      return 'warn' // this.budgetBalancePercent <= 0 ? 'danger' : 'warn'
    }
  },

  methods: {
    setTitle() {
      this.widget
        .chartComponent
        .chartOpts
        .customSettings = {
          ...this.widget.chartComponent.chartOpts.customSettings,
          chartGroupValue: this.title
        }

      this.widget
        .chartComponent
        .chartOpts
        .axisY = {
          ...this.widget.chartComponent.chartOpts.axisY,
          offset: -50,
          labelInterpolationFnc: () => ''
        }
    },

    setData() {
      this.$refs.programSpend.$refs.chart.api = {
        get: () => Promise.resolve({
          data: {
            ChartData: this.data
          }
        })
      }
    }
  }
}

</script>

<style scoped lang='scss'>

.program-spend-widget {
  @at-root #layout &.card {
    display: block;
  }

  &.card >>> {
    .legend {
      display: none;
    }
    .empty {
      .noData {
        display: none;
      }
    }
    .card-chart-tall {
      height: unset;
      min-height: 50px;

      &.noData {
        height: unset !important;
        margin-top: -20px;
      }
    }
    .chart-header {
      border: none;
      padding-top: 8px;
      padding-left: 12px;
      margin-bottom: -10px;

      .chartHeaderText {
        font-size: 13px;
      }
    }
    .ct-chart {
      height: 48px;
      overflow: hidden;
    }
    .ct-label {
      transform: translate(0px, 3px);
    }
    .ct-target-line {
      stroke: none;
    }
  }

  &.card--notice >>> {
    .card-chart-tall {
      min-height: 100px;
    }
  }

  &__notice.dawn-notification {
    margin: -5rem auto 2rem auto;
    width: 92%;
    overflow: visible;
    min-height: 2.15em;

    >>> .icon-wrapper.icon-wrapper {
      left: -1px;
      height: calc(100% + 1px);
      line-height: unset;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/components/programBudget.vue